/** KDS Inline Table Header — banner row for bulk actions and contextual messaging (node 790:29058). */

import type { LucideIcon } from 'lucide-react';
import { CircleAlert, CircleCheckBig, Info } from 'lucide-react';

export const inlineTableHeaderTypes = ['actions', 'info', 'warning', 'error', 'selected'] as const;
export type InlineTableHeaderType = (typeof inlineTableHeaderTypes)[number];

export const inlineTableHeaderIconSize = '20px';

export const inlineTableHeaderIconMap: Partial<Record<InlineTableHeaderType, LucideIcon>> = {
  actions: CircleCheckBig,
  info: Info,
  warning: CircleAlert,
  error: Info,
};

export const inlineTableHeaderIconColorMap: Partial<Record<InlineTableHeaderType, string>> = {
  actions: 'var(--ks-colors-brand-500)',
  info: 'var(--ks-colors-blue-700)',
  warning: 'var(--ks-colors-orange-700)',
  error: 'var(--ks-colors-red-700)',
};

export const inlineTableHeaderActionLinkColorMap: Record<string, string> = {
  actions: 'brand.500',
  info: 'blue.700',
  warning: 'orange.700',
  error: 'red.700',
};

export type InlineTableHeaderActionVariant = 'default' | 'destructive';

export interface InlineTableHeaderAction {
  label: string;
  icon?: LucideIcon;
  variant?: InlineTableHeaderActionVariant;
  onClick?: () => void;
}

export const inlineTableHeaderActionColorMap: Record<InlineTableHeaderActionVariant, string> = {
  default: 'var(--ks-colors-brand-500)',
  destructive: 'var(--ks-colors-red-700)',
};
